// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202610261139/js/" + chunkId + "." + {"44":"1dd4b3a7","225":"dd036d14","481":"9c4fc269","486":"3d26dccd","770":"2caeda0d"}[chunkId] + ".0.05464861703423063.chunk.js";
};